import request from '@/utils/request'

export function pay(item, provider) {
  return request({
    url: '/payment/' + provider + '/pay/' + item,
    method: 'get',
  })
}

